import {
  GET_ANNOUNCEMENTS_PENDING,
  GET_ANNOUNCEMENTS_FULFILLED,
  GET_ANNOUNCEMENTS_REJECTED,
} from "../actions/announcement";

const initialState = {
  fetching: false,
  announcements: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENTS_PENDING:
      return {
        ...state,
        fetching: true,
      };
    case GET_ANNOUNCEMENTS_FULFILLED:
      return {
        ...state,
        fetching: false,
        announcements: action.payload,
      };
    case GET_ANNOUNCEMENTS_REJECTED:
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/announcementReducer.js